
import React, { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllProperties } from '../../redux/actions/propertyActions';
import { get_provinces } from '../../redux/actions/provinceAction';
import PropertyList from '../../components/Property/PropertyList';
import Loader from 'components/Loader';

const Properties = () => {
  const dispatch = useDispatch();
  const { properties, pagination, loading, error } = useSelector((state) => state.property);
  const { provinces = [] } = useSelector((state) => state.province || {});

  const [page, setPage] = useState(1);


  // Filter handler

  // const handleFilter = (filter = {}) => {
  //   setPage(1);
  //   dispatch(
  //     fetchAllProperties({
  //       ...filter,
  //       page,
  //       limit: 10
  //     })
  //   );
  // };

  const handleFilter = (filter = {}) => {
    setPage(1);
  
    dispatch(
      fetchAllProperties({
        ...filter,
        page: 1,     
        limit: 10
      })
    );
  };

  useEffect(() => {
    dispatch(fetchAllProperties({ page, limit: 10 }));
    dispatch(get_provinces());
  }, [dispatch, page]);

  return (
    <div>
      {loading && <Loader />}
      <h2>All Properties</h2>
      <PropertyList
        properties={properties}
        pagination={pagination}
        page={page}
        setPage={setPage}
        onFilter={handleFilter}
        provinces={provinces}
        loading={loading}
      />

    </div>
  );
};

export default Properties;
